

// src/components/songEdit/components/RemovableBadge.tsx
import React from 'react';

interface RemovableBadgeProps {
  text: string;
  onRemove: () => void;
}

export const RemovableBadge: React.FC<RemovableBadgeProps> = ({ text, onRemove }) => (
  <span className="tags-input__tag">
    {text}
    <button
      type="button"
      className="tags-input__tag-remove"
      onClick={onRemove}
    >
      ×
    </button>
  </span>
);